// ========================================================
// https://codepen.io/KilledByAPixel/pen/BaowKzv
// https://zzfx.3d2k.com/
// ========================================================

export const SUCCESSFUL_CLICK_SFX = [0.1, 0, 1874, null, 0.01, 0.25, 2, 0.76, null, null, 622, 0.1];
export const UNSUCCESSFUL_CLICK_SFX = [0.5, 0, 63, 0.02, null, 0.09, 1, 1.87, null, null, 1, 0.96, null, null, null, 0.2];
export const TIMER_SECONDS_TICK_SFX = [0.2, 0, 11, 0.01, 0.01, 0.01, 3, 0.1, 0.5];
export const COUNTDOWN_TIMER_BING_SFX = [0.2, 0, 1000, null, 0.01, 0.26, null, 1.19];
export const COUNTDOWN_TIMER_BING_END_SFX = [0.2, 0, 2000, null, 0.01, 0.26, null, 1.19];
export const BOARD_COMPLETE_SFX = [0.2, 0, 663, 0.24, 0.42, 0.61, null, 0.91, null, null, -394, 0.02, 0.11, null, null, null, 0.16];
